// extracted by mini-css-extract-plugin
module.exports = {"input":"CheckboxInternals_input__u2F8O","label":"CheckboxInternals_label__ITfdv","green":"CheckboxInternals_green__cjDyk"};